import { Box, Stack, Typography } from '@customink/pigment-react';
import {
  usePricing,
  useQuotedVouchers,
} from '@customink/project-service-react-components';
import Big from 'big.js';

import { LineItem } from './LineItem';

import { PgmntColorFeedbackSuccessAccessible } from '@/utils/designTokens';

export function VoucherLineItem() {
  const voucherData = useQuotedVouchers();
  const { isLoading, isFetching } = usePricing();

  // Get the total voucher discount from all grouped pricing data
  const voucherDiscountValue = voucherData?.totalDiscount || '0.00';
  const partiallyAppliedMessage = voucherData?.partiallyAppliedMessage;

  const voucherDiscount = `-$${voucherDiscountValue}`;
  const voucherDiscountApplied = Big(voucherDiscountValue).gt(0);

  // Only show the voucher line item if there's an applicable voucher
  return (
    <>
      {voucherDiscountApplied && (
        <Stack spacing={0.25} useFlexGap>
          <LineItem
            isLoading={isFetching || isLoading}
            name="Voucher Discount"
            sxValue={{ color: PgmntColorFeedbackSuccessAccessible }}
            tagPrefix="voucher"
            value={voucherDiscount}
          />
          {partiallyAppliedMessage && (
            <Typography
              color={PgmntColorFeedbackSuccessAccessible}
              data-testid="voucher-partial-error"
              variant="uiTextTiny"
            >
              {partiallyAppliedMessage}
            </Typography>
          )}
        </Stack>
      )}
    </>
  );
}
